import { debounce as E } from "@yeger/debounce";
function _({
  columns: u,
  columnWidth: l,
  emit: v,
  gap: s,
  items: c,
  maxColumns: d,
  minColumns: w,
  nextTick: z,
  onBeforeUnmount: A,
  onMounted: M,
  rtl: g,
  scrollContainer: O,
  ssrColumns: f,
  vue: k,
  wall: a,
  watch: h
}) {
  function b(r, e, n, t) {
    const o = y(n);
    return t + e + o <= r ? b(
      r,
      e,
      n + 1,
      t + e + o
    ) : n;
  }
  function y(r) {
    const e = Array.isArray(l.value) ? l.value : [l.value];
    return e[r % e.length];
  }
  function x() {
    const r = b(
      a.value.getBoundingClientRect().width,
      s.value,
      0,
      // Needs to be offset my negative gap to prevent gap counts being off by one
      -s.value
    ), e = D(Y(r));
    return e > 0 ? e : 1;
  }
  function Y(r) {
    const e = d?.value;
    return e && r > e ? e : r;
  }
  function D(r) {
    const e = w?.value;
    return e && r < e ? e : r;
  }
  if (f.value > 0) {
    const r = B(f.value);
    c.value.forEach(
      (e, n) => r[n % f.value].push(n)
    ), u.value = r;
  }
  let p = 0;
  async function C(r, e) {
    if (r >= c.value.length || (await z(), p !== e))
      return;
    const n = [...a.value.children];
    g.value && n.reverse();
    const t = n.reduce(
      (o, T) => T.getBoundingClientRect().height < o.getBoundingClientRect().height ? T : o
    );
    u.value[+t.dataset.index].push(r), await C(r + 1, e);
  }
  async function i(r = !1) {
    const e = x();
    if (u.value.length === e && !r) {
      v(k === 2 ? "redraw-skip" : "redrawSkip");
      return;
    }
    u.value = B(e);
    const n = O?.value, t = n ? n.scrollTop : window.scrollY;
    await C(0, ++p), n ? n.scrollBy({ top: t - n.scrollTop }) : window.scrollTo({ top: t }), v("redraw");
  }
  const R = typeof ResizeObserver > "u" ? void 0 : new ResizeObserver(E(() => i()));
  return M(() => {
    i(), R?.observe(a.value);
  }), A(() => R?.unobserve(a.value)), h([c, g], () => i(!0)), h([l, s, w, d], () => i()), { getColumnWidthTarget: y };
}
function B(u) {
  return Array.from({ length: u }).map(() => []);
}
export {
  _ as useMasonryWall
};
